import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgHealthTopic({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.556 16l.021-.028c.178.156.362.31.551.463a20.911 20.911 0 003.856 2.454l.438-.237a23.392 23.392 0 001.097-.65h3.442a25.004 25.004 0 01-3.865 2.56l-.459.24-.213.104-.407.19-.542-.235a21.426 21.426 0 01-1.367-.7 22.876 22.876 0 01-3.236-2.17 17.506 17.506 0 01-2.106-1.99h2.79zm5.024-7.858a1 1 0 011.283.348l.058.101 2.422 4.856a1 1 0 00.77.546l.125.007H22a1 1 0 01.117 1.994L22 16h-5.381a2 2 0 01-1.712-.966l-.078-.141-1.483-2.973a.5.5 0 00-.821-.108l-.054.072-1.639 2.707a1 1 0 01-1.703.013l-.056-.103-.802-1.693a.5.5 0 00-.802-.142l-.058.068-.295.418a2 2 0 01-1.473.842L5.48 14H2a1 1 0 01-.117-1.993L2 12h2.963a1 1 0 00.741-.33l.076-.094 1.476-2.095a1 1 0 011.666.045l.056.102.709 1.496a.5.5 0 00.826.118l.053-.073 1.605-2.65a1 1 0 01.409-.377zm-.53-3.939C16.616 1.386 22 3.88 22 9.347c0 .912-.152 1.797-.44 2.654h-2.153c.388-.868.593-1.755.593-2.654 0-3.926-3.834-5.593-7.222-3.23l-.181.13-.658.49-.61-.55C8.479 3.611 4 5.426 4 9.347c0 .22.01.437.032.653H2.024A8.842 8.842 0 012 9.348C2 3.93 7.935 1.26 12.05 4.203z"
        fill={color}
      />
    </svg>
  )
}

export default SvgHealthTopic
